var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarcolit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M25.38 12.415L13.707.329c-.173-.18-.4-.283-.634-.316l-.039-.006C12.99.003 12.947 0 12.903 0c-.044 0-.088.003-.132.007l-.038.006c-.235.033-.461.136-.635.316L.425 12.415c-.165.17-.154.438.023.596l1.032.918c.177.159.455.148.62-.023L12.903 2.722l10.802 11.184c.166.17.443.182.621.023l1.03-.918c.178-.158.189-.425.024-.596",
    transform: "translate(.546 .78)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M25.107 12.054H.774c-.428 0-.774.347-.774.774v.453c0 .427.346.774.774.774H.83l2.545 11.512c.226 1.025 1.23 1.763 2.395 1.763H20.11c1.166 0 2.168-.738 2.395-1.763l2.546-11.512h.055c.428 0 .774-.347.774-.774v-.453c0-.427-.346-.774-.774-.774zm-16.5 10.414c0 .573-.465 1.037-1.037 1.037-.573 0-1.037-.464-1.037-1.037v-6.697c0-.573.464-1.037 1.037-1.037.572 0 1.037.464 1.037 1.037v6.697zm5.37 0c0 .573-.463 1.037-1.037 1.037-.572 0-1.037-.464-1.037-1.037v-6.697c0-.573.465-1.037 1.037-1.037.574 0 1.037.464 1.037 1.037v6.697zm5.371 0c0 .573-.464 1.037-1.037 1.037s-1.036-.464-1.036-1.037v-6.697c0-.573.463-1.037 1.036-1.037s1.037.464 1.037 1.037v6.697z",
    transform: "translate(.546 .78)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarcolit);
export default __webpack_public_path__ + "static/media/marcolit.ce92863e1eba0453524688b7ff2754bc.svg";
export { ForwardRef as ReactComponent };